export const LEGACY_WOKA_FRAME_SIZE = 32;
export const PLATFORM_WOKA_FRAME_SIZE = 64;

export function getWokaFrameSize(textureId: string): number {
  return textureId.startsWith("char-") || textureId.startsWith("lpc-")
    ? PLATFORM_WOKA_FRAME_SIZE
    : LEGACY_WOKA_FRAME_SIZE;
}

export function getWokaFrameConfig(textureId: string): {
  frameWidth: number;
  frameHeight: number;
} {
  const frameSize = getWokaFrameSize(textureId);
  return { frameWidth: frameSize, frameHeight: frameSize };
}

export function getWokaSpriteOffsetY(frameSize: number): number {
  return (LEGACY_WOKA_FRAME_SIZE - frameSize) / 2;
}

export function getWokaLabelOffsetY(frameSize: number): number {
  return -18 - (frameSize - LEGACY_WOKA_FRAME_SIZE);
}

export function getWokaVideoOffsetY(frameSize: number): number {
  return 36 + (frameSize - LEGACY_WOKA_FRAME_SIZE);
}
